import Profile from './Profile';
import withUser from '../context/withUser';

export default withUser(Profile);



// WEBPACK FOOTER //
// ./src/components/profile/ProfileContainer.js